import React from 'react';
import { Tabs } from 'antd';
import BannerPage from '../banner/page';
import DiagnosisIconPage from '../diagnosis-icon/page';
import NewRankConditionPage from '../new-rank-condition/page';
import RankingLevelsPage from '../ranking-levels/page';
import StiDocumentsPage from '../sti-documents/page';
export default function SettingPage() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "min-h-screen bg-[#f5f5f5] px-6 py-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-4 text-[24px] font-semibold text-[#111827]"
    }, "\u8A2D\u5B9A"), /*#__PURE__*/ React.createElement(Tabs, {
        defaultActiveKey: "rank-levels",
        items: [{
                key: 'banner',
                label: 'バナー一覧',
                children: /*#__PURE__*/ React.createElement(BannerPage, {
                    embedded: true
                })
            }, {
                key: 'icon',
                label: 'アイコン一覧',
                children: /*#__PURE__*/ React.createElement(DiagnosisIconPage, {
                    embedded: true
                })
            }, {
                key: 'rank-levels',
                label: 'ランク一覧',
                children: /*#__PURE__*/ React.createElement(RankingLevelsPage, {
                    embedded: true
                })
            }, {
                key: 'rank-condition',
                label: 'ランク条件一覧',
                children: /*#__PURE__*/ React.createElement(NewRankConditionPage, {
                    embedded: true
                })
            }, {
                key: 'sti-documents',
                label: '性病検査審査',
                children: /*#__PURE__*/ React.createElement(StiDocumentsPage, {
                    embedded: true
                })
            }]
    })));
}
